import React from "react";
import { DonateForm } from "../components/DonateForm";
import { Helmet } from "react-helmet";

export const DonateExternal: React.FC = () => {
    return(
        <div className="p-3">
            <DonateForm endpoint={"donation/create"} />
        </div>
    );
}